/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TEXT from "../../../../../src/utils/globalText";
import ICONS from "../../../../assets/Icons";
import BeneficiaryAccountViewAllPopup from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountViewAllPopup/index.jsx";
import AdditionalRecipient from "../../../../components/AdditionalRecipient";
import Loader from "../../../../components/Loader/Index";
import useServiceChecker from "../../../../components/ServiceChecker";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import Chips from "../../../../components/_utils/CommonButtons/Chips";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import IFSCDetails from "../../../../containers/Settings/IFSCDetails";
import GSTVerification from "../../../../containers/Settings/GSTDetails";
import PanVerification from "../../../../containers/Settings/PanVerification";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import {
  addBeneficiaryAccountLabel,
  approveBeneficiaryAccount,
  archiveBeneficiaryAccount,
  beneficiaryAccountDetailsById,
  rejectBeneficiaryAccount,
  removeBeneficiaryAccountLabel,
  resetBeneficiaryAccountDetailsById,
  resetBeneficiaryBankUpdate,
  resetUpdateBeneficiaryAccount,
  unarchiveBeneficiaryAccount,
  updateBeneficiaryAccount,
} from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  getRefreshTokenNew,
  resetServices,
} from "../../../../redux/features/refreshToken/refreshToken";
import {
  bankLookUp,
  panLookUp,
  verifyPAN,
} from "../../../../redux/features/sharedResources/sharedResources";
import {
  beneficiaryTransactionsReject,
  beneficiaryTransactionsViewAll,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import { scheduledBeneficiaryReject } from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
  TimelineConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import useCategories from "../../../../utils/useCategories";
import BeneficiaryTransactionViewall from "../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall";
import ScheduleBeneficiaryTransactionViewSchedules from "../../../Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules";
import "./index.css";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import globalText from "../../../../../src/utils/globalText";
import BeneAccountDeclinePopup from "../../../../components/Accounts/BeneficiaryAccount/BeneAccountDeclinePopup/index.js";
import BeneficiaryTransactionViewAllPopup from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionViewAllPopup/index.jsx";
import CommonEditHistoryPopUp from "../../../../components/_utils/CommonEditHistoryPopup/index.jsx";

const BeneficiaryAccountDetails = (payload) => {
  const [ensureAll] = useServiceChecker();
  const categoryMapper = useCategories();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [labels, setLabels] = useState([]);
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [loading, setLoading] = useState(true);
  const [deniedId, SetdeniedId] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [openLabelSearchPopup, setOpenLabelSearchPopup] = useState(false);
  const [labelName, setLabelName] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [clickedBtn, setClickedBtn] = useState(null);
  const [nameArchive, setNameArchive] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [activeType, setActiveType] = useState("pan");
  const [labelDetails, setLabelDetails] = useState([]);
  const [declineReason, setDeclineReason] = useState("");
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [associatePending, setassociatePending] = useState("");
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [associateschedule, setassociateschedule] = useState("");
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [ViewAccountDetails, SetViewAccountDetails] = useState([]);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [preventMultiEnter, setPreventMultiEnter] = useState(false);
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [additionalRecipient, setAdditionalRecipicent] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [labelLoading, setLabelLoading] = useState(false);
  const [archiveType, setArchiveType] = useState("");
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [showCategories, setShowCategories] = useState(
    payload?.showCategory ?? false,
  );
  const [showContactDetails, setShowContactDetails] = useState(
    payload?.showCategory ? false : true,
  );

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    categoryIds: [],
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });

  const [bankDetails, setBankDetails] = useState({
    name: "",
    bankAccountNumber: "",
    ifscCode: "",
  });
  const [previousContactDetails, setPreviousContactDetails] = useState({
    legalName: "",
    contact: "",
    email: "",
    gstin: "",
    category: null,
  });

  const [index, setIndex] = useState(
    showContactDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showCategories
        ? GlobalConfiguration?.lengthCheckOne
        : showAssignedLabels
          ? GlobalConfiguration?.lengthCheckTwo
          : additionalRecipient
            ? GlobalConfiguration?.lengthCheckThree
            : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");
  const [additionalSupport, setAdditionalSupport] = useState(false);
  const [tooltip, setTooltip] = useState("Copy to clipboard");
  const [editHistoryPopUp, setEditHistoryPopUp] = useState(false);
  const copyTextRef = useRef(null);

  const {
    beneficiaryTransactionsViewAllData,
    beneficiaryTransactionsViewAllLoading,
  } = useSelector((state) => state.beneficiaryTransactions);

  const accountType = location.pathname.includes("beneficiary_account")
    ? "beneficiary"
    : location.pathname.includes("internal_account")
      ? "internal"
      : "";
  const pathName = location?.state?.from ? location?.state?.from : "";
  const txn_single_appr = location?.state?.type ? location?.state?.type : "";

  const { beneficiaryAccountDetailsData } = useSelector(
    (state) => state.beneficiaryAccount,
  );

  const { rejectBeneficiaryAccountData, rejectBeneficiaryAccountLoading } =
    useSelector((state) => state.beneficiaryAccount);

  const { scheduledBeneficiaryViewLoading, scheduledBeneficiaryViewData } =
    useSelector((state) => state?.scheduleBeneficiaryTransactions);

  const services = useSelector((state) => state.refreshToken.services);

  const sliceCategory = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const isPopup = payload?.type === "bene_account_detail_modal";

  const canEdit = services?.some(
    (service) =>
      service === "BUAccount" ||
      (service === "Admin" && payload?.servicesType !== "BenAdmin"),
  );

  const beneficiaryAccount =
    beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

  const accountStatus = beneficiaryAccount?.approval_status;

  const canArchive = services?.some(
    (service) => service === "BAAccountArchive" || service === "Admin",
  );

  const isArchived = accountStatus === "archived";
  const isBlocked = accountStatus === "blocked";

  const isArchiveDisabled = isPopup || isBlocked || !canArchive;

  const isEditDisabled = isPopup || isArchived || isBlocked || !canEdit;

  const categoryIds = beneficiaryAccount?.category_ids || [];
  const categoryNames =
    beneficiaryAccount?.category_ids
      ?.map((item) => item.category_name)
      .join(", ") || "";

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    if (
      beneficiaryAccountDetailsData &&
      beneficiaryAccountDetailsData.beneficiary_accounts &&
      beneficiaryAccountDetailsData.beneficiary_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { pan_legal_name, contact_no, email_id } = beneficiaryAccount;
      setPreviousContactDetails({
        legalName: pan_legal_name,
        contact: contact_no,
        email: email_id,
        category_ids: beneficiaryAccount?.category_ids || [],
      });
    }
  }, [beneficiaryAccountDetailsData]);

  // useEffect(() => {
  //   if (
  //     beneficiaryAccountDetailsData?.beneficiary_accounts?.length >
  //     GlobalConfiguration.lengthCheckZero
  //   ) {
  //     setCategoryIds(beneficiaryAccount?.category_ids || []);
  //   }
  // }, [beneficiaryAccountDetailsData, beneficiaryAccount]);

  const handleSupportIdCopy = async () => {
    const accountId =
      beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.id;
    if (!accountId) return;
    try {
      await navigator.clipboard.writeText(accountId);
      setTooltip("Copied");
      clearTimeout(copyTextRef.current);
      copyTextRef.current = setTimeout(() => {
        setTooltip("Copy to clipboard");
      }, IntervalConfiguration.intervalMedium);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (
      beneficiaryAccountDetailsData &&
      beneficiaryAccountDetailsData.beneficiary_accounts &&
      beneficiaryAccountDetailsData.beneficiary_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { bank_acc_no, name, ifsc_code } = beneficiaryAccount;
      setBankDetails({
        bankHolderName: name,
        bankAccountNumber: bank_acc_no,
        ifscCode: ifsc_code,
      });
    }
  }, [beneficiaryAccountDetailsData]);

  function handleChipClick(id) {
    if (selectedChipIndex === id) {
      setSelectedChipIndex(null);
    } else {
      setSelectedChipIndex(id);
    }
  }

  const chipsArray = [
    {
      text: globalText.IFSC_CODE,
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: true,
      hoverOption: "blue",
      bulletPoint: [
        "Contact the Xpentra administrator to change the IFSC detail.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckZero),
    },
    {
      text: "Name, Contact number, Email ID",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Only the newly linked user will have access to this account after the change.",
      ],
      hoverOption: "blue",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Categories",
      selected: selectedChipIndex === TimelineConfiguration.barWidthMedium,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "Proceed with caution when assigning all categories to the same account.",
      ],
      hoverOption: "blue",
    },
    {
      text: `${globalText.PAN_NUMBER}, ${globalText.GST_NUMBER}`,
      selected: selectedChipIndex === TimelineConfiguration.barWidthLarge,
      disabled: false,
      bulletPoint: [
        "Account will be marked as pending and will require approval.",
        "Pending transactions associated with a pending account cannot be approved.",
        "If GST was entered during creation, it is required during editing.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckThree),
      hoverOption: "blue",
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      disabled: false,
      bulletPoint: [
        "It will be created as a new beneficiary account and archive the old account.",
        "New beneficiary account will remain pending and will require approval.",
        "Pending transactions associated with this account must be rejected.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckFour),
      hoverOption: "blue",
    },
  ];

  const handleAlertSchedule = () => {
    setshowPopupReject(true);
  };

  const handleAccRejectAlert = () => {
    // setRejectTxnPopup(false);
    setshowPopupReject(true);
  };

  const handleConfirmDecline = async (id, rejection_reason) => {
    setShowLoader(true);
    setshowPopupReject(false);
    UniversalRefreshToast("accountsRefresh");

    if (rejectBeneficiaryAccountLoading) return;

    const result = await dispatch(
      rejectBeneficiaryAccount({
        id,
        rejection_reason,
      }),
    );

    toast.dismiss();

    // Rejected
    if (rejectBeneficiaryAccount.rejected.match(result)) {
      const errorData = result.payload || {};
      let errorMsg = "An error occurred while taking action on this account.";

      if (errorData?.errors?.beneficiary_account?.length) {
        errorMsg = errorData.errors.beneficiary_account[0];
      } else if (errorData?.errors?.bank_account_number?.length) {
        errorMsg = errorData.errors.bank_account_number[0];
      } else if (errorData?.errors?.category?.length) {
        errorMsg = errorData.errors.category[0];
      } else if (typeof errorData === "string") {
        errorMsg = errorData;
      }

      // Refresh details if already rejected
      if (errorMsg === "Beneficiary account already rejected") {
        const newData = await dispatch(beneficiaryAccountDetailsById({ id }));

        const updatedBeneficiaryAccount =
          newData?.payload?.beneficiary_accounts?.[0];

        updateAllAccounts(
          ViewAccountDetails.map((item) =>
            item.id === id
              ? {
                  ...item,
                  ...updatedBeneficiaryAccount,
                  error: true,
                  error_msg: errorMsg,
                }
              : item,
          ),
        );
      } else {
        updateAllAccounts(
          ViewAccountDetails.map((item) =>
            item.id === id
              ? {
                  ...item,
                  error: true,
                  error_msg: errorMsg,
                }
              : item,
          ),
        );
      }

      CommonToast({
        text: errorMsg,
        icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
      setDeclineReason("");
      handleClosePopup();
      return;
    }

    // Fulfilled
    const account = result.payload?.beneficiary_accounts?.[0];

    updateAllAccounts(
      ViewAccountDetails.map((item) =>
        item.id === id
          ? {
              ...item,
              approval_status: "rejected",
              rejected_on: account?.rejected_on,
              rejected_by_name: account?.rejected_by_name,
              rejection_reason,
              error: false,
              message: "",
            }
          : item,
      ),
    );

    await dispatch(beneficiaryAccountDetailsById({ id }));

    setShowLoader(false);
    setDeclineReason("");
    setRejectTxnPopup(false);
    handleClosePopup();

    CommonToast({
      text: "Account rejected successfully.",
      icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });

    if (isPopup) {
      setTimeout(() => {
        payload?.closeBeneAccountDetailModal();
        window.location.reload();
      }, IntervalConfiguration.intervalExtraLarge);
    }

    if (pathName) {
      setTimeout(() => {
        navigate(pathName);
      }, IntervalConfiguration.intervalPopup);
    }
  };

  const handleApply = () => {
    dispatch(resetServices());
    dispatch(getRefreshTokenNew());
    dispatch(resetUpdateBeneficiaryAccount());
    dispatch(resetBeneficiaryBankUpdate());

    switch (selectedChipIndex) {
      case 0: // IFSC Code
        break;

      case 1: // Account name, Contact number, Email
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_account_details/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 2: // Assigned categories
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_categories/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 3: // PAN Number, GST
        dispatch(resetBeneficiaryAccountDetailsById());
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_PAN_details/${id}`,
        );
        break;

      case 4: // Bank account number
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/edit_bank_details/${id}`,
          {
            state: bankDetails,
          },
        );
        dispatch(resetBeneficiaryBankUpdate());
        break;

      default:
        break;
    }
  };

  async function fetchData() {
    if (!showLabelsPopup) setLoading(true);
    try {
      let response;
      if (isPopup) {
        response = await dispatch(
          beneficiaryAccountDetailsById({ id: payload?.bene_account_id }),
        );
        setLabelDetails(
          response?.payload?.beneficiary_accounts?.[0]?.labels || [],
        );
        setShowAdditionalRecipient(
          response?.payload?.beneficiary_accounts?.[0]?.recipient_email || [],
        );
      } else {
        response = await dispatch(beneficiaryAccountDetailsById({ id }));
        setLabelDetails(
          response?.payload?.beneficiary_accounts?.[0]?.labels || [],
        );
        setShowAdditionalRecipient(
          response?.payload?.beneficiary_accounts?.[0]?.recipient_email || [],
        );
        setAdditionalChip(
          response?.payload?.beneficiary_accounts?.[0]?.recipient_email || [],
        );
      }
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      setLoading(false);
      console.error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }
  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (recipientButtonDisabled) return;
    const recipientString = [...recipients, ...additionalChip].join(",");
    let response = await dispatch(
      updateBeneficiaryAccount({ id: id, recipient_email: recipientString }),
    );
    if (response?.payload?.status) {
      setShowAdditionalSection(false);
      await fetchData();
      setRecipients([]);
    } else {
      setShowAdditionalSection(false);
    }
  };
  const handleClose = () => {
    setShowLabelsPopup(false);
    fetchData();
  };
  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedChipIndex(null);
  };

  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration?.panLength) {
      const response = await dispatch(verifyPAN({ search_string: pan }));
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (response?.payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BUAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: response?.payload?.errors?.base[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  useEffect(() => {
    const TransactionData = async () => {
      await dispatch(
        beneficiaryTransactionsViewAll({
          beneficiary_account_id:
            beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.id,
          lifecycle_status: "pending",
        }),
      );
    };
    if (beneficiaryAccountDetailsData) TransactionData();
  }, [beneficiaryAccountDetailsData]);

  const isAccountArchived =
    beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]
      ?.approval_status === "archived";

  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");

  const isServiceMissing = !(hasALabel && hasRLabel);

  const handleClick = () => {
    if (isArchived) return;

    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  const handleModalOpen = (id) => {
    if (isEditDisabled) return;
    setIsEditModalOpen(id);
  };

  const handleCloseModal = () => {
    if (accountType === "beneficiary") {
      setAchivedOpenPop(false);
      setOpenBeneAssociate(false);
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(false);
      setAchivedOpenPop(false);
    }
  };
  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${payload.bene_account_id}`,
    });
  };

  const handleUnarchive = () => {
    if (
      beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.archived === "N"
    ) {
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(true);
    }
  };

  const handleArchive = () => {
    if (isArchiveDisabled) return;
    if (
      beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]?.archived === "N"
    ) {
      setAchivedOpenPop(true);
    } else {
      setAchivedOpenPop(false);
    }
  };

  const toggleCategories = () => {
    setShowCategories(true);
    setShowContactDetails(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration?.lengthCheckOne);
  };

  const toggleContactDetails = () => {
    setShowContactDetails(true);
    setShowCategories(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration?.lengthCheckZero);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowCategories(false);
    setShowContactDetails(false);
    setAdditionalRecipicent(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration?.lengthCheckTwo);
  };

  const toggleAdditionalRecipicent = () => {
    setAdditionalRecipicent(true);
    setShowAssignedLabels(false);
    setShowCategories(false);
    setShowContactDetails(false);
    setAdditionalSupport(false);
    setIndex(GlobalConfiguration?.lengthCheckThree);
  };

  const toggleSupportDetails = () => {
    setAdditionalSupport(true);
    setAdditionalRecipicent(false);
    setShowAssignedLabels(false);
    setShowCategories(false);
    setShowContactDetails(false);
    setIndex(GlobalConfiguration?.lengthCheckFour);
  };

  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };

  const asAcc =
    beneficiaryAccountDetailsData?.beneficiary_accounts[0]?.associate_bank ===
      "Y" ||
    beneficiaryAccountDetailsData?.beneficiary_accounts[0]?.associate_pan ===
      "Y";

  const pendingTxn =
    beneficiaryAccountDetailsData?.beneficiary_accounts[0]
      ?.pending_beneficiary_transactions === "Y";

  const associatedCategories =
    beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]
      ?.all_category_assign === "Y";

  const scheduleTxn =
    beneficiaryAccountDetailsData?.beneficiary_accounts[0]
      ?.pending_scheduled_beneficiary_transactions === "Y";

  const buildAlerts = () => [
    ...(associatedCategories !== undefined
      ? associatedCategories
        ? [
            {
              isLoading: false,

              text: "All categories are assigned to this account",
              icon: ICONS?.ALERT,
              onClick: () => {
                toggleCategories();
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking category assign",
          },
        ]),
    ...(asAcc !== undefined
      ? asAcc
        ? [
            {
              isLoading: false,
              isDisabled: isPopup,
              text: "Associated accounts are found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (isPopup) {
                  actionRestricted();
                } else {
                  setRemPan(currentAccountDetails.pan);
                  openAssociatedAccountsFound();
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking associated account",
          },
        ]),

    ...(pendingTxn !== undefined
      ? pendingTxn &&
        beneficiaryAccountDetailsData?.beneficiary_accounts[0]
          ?.approval_status === "pending"
        ? [
            {
              isLoading: false,
              isDisabled: isPopup,
              text: "Pending transactions found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (isPopup) {
                  actionRestricted();
                  return;
                } else {
                  // const hasAccess =
                  //   services?.includes("ABeneficiaryTxn") ||
                  //   services?.includes("Admin");

                  // if (!hasAccess) {
                  //   navigate("/feature_not_assigned", {
                  //     state: { unavailableService: "ABeneficiaryTxn" },
                  //   });
                  //   return;
                  // }

                  setRejectTxnPopup(true);
                  setassociatePending("AlertPendingTxn");
                  setassociateschedule("");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking pending transactions",
          },
        ]),

    ...(scheduleTxn !== undefined
      ? scheduleTxn &&
        beneficiaryAccountDetailsData?.beneficiary_accounts[0]
          ?.approval_status === "pending"
        ? [
            {
              isLoading: false,
              isDisabled: isPopup,
              text: "Pending schedules found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (isPopup) {
                  actionRestricted();
                  return;
                } else {
                  // const hasAccess =
                  //   services?.includes("BAScheduledTxn") ||
                  //   services?.includes("Admin");

                  // if (!hasAccess) {
                  //   navigate("/feature_not_assigned", {
                  //     state: { unavailableService: "BAScheduledTxn" },
                  //   });
                  //   return;
                  // }

                  setShowScheduleTxnPopup(true);
                  setassociateschedule("AlertSchedule");
                  setassociatePending("");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking schedules transactions",
          },
        ]),
  ];

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const handleRejectAllTransaction = async () => {
    setShowLoader(true);

    const id2 =
      !beneficiaryTransactionsViewAllLoading &&
      beneficiaryTransactionsViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? beneficiaryTransactionsViewAllData.transactions.map(
            (data) => data.txn_id,
          )
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        beneficiaryTransactionsReject({
          id: id2,
          reason: declineReason,
        }),
      );
    } else {
      data = { payload: { status: true } };
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "ABeneficiaryTxn",
        },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (beneficiaryTransactionsReject.rejected.match(data)) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data.payload.errors.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
      setshowPopupReject(false);
    } else if (beneficiaryTransactionsReject.fulfilled.match(data)) {
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      setRejectTxnPopup(false);
      setshowPopupReject(false);
      setShowLoader(false);
      await dispatch(
        beneficiaryAccountDetailsById({
          id: payload?.bene_account_id || id,
        }),
      );
      if (
        beneficiaryAccountDetailsData?.beneficiary_accounts?.[0]
          ?.pending_scheduled_beneficiary_transactions === "Y"
      ) {
        setShowScheduleTxnPopup(true);
        setRejectTxnPopup(false);
      } else if (archiveType === "archive") {
        await archiveAccount();
      } else {
        if (isPopup) {
          setTimeout(() => {
            handleConfirmDecline(payload?.bene_account_id, declineReason);
          }, IntervalConfiguration.intervalSmaller);
        } else {
          setTimeout(() => {
            handleConfirmDecline(id, declineReason);
          }, IntervalConfiguration.intervalSmaller);
        }
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
      setTimeout(() => {
        setRejectTxnPopup(false);
      }, IntervalConfiguration.intervalMedium);
      setDeclineReason("");
    }

    if (payload?.flow === "schedule_single_approval") {
      setTimeout(() => {
        payload?.closeBeneAccountDetailModal();
        window.location.reload();
      }, IntervalConfiguration.intervalExtraLarger);
    }
  };

  const handleRejectAlert = async () => {
    setShowLoader(true);
    try {
      const queryParams = {
        page_no: GlobalConfiguration.lengthCheckOne,
        page_item_count: PaginationConfiguration.paginationSmall,
        lifecycle_status: "pending",
        beneficiary_account_id: id,
      };

      const response = await dispatch(
        beneficiaryTransactionsViewAll(queryParams),
      );
      const data = response?.payload?.transactions;

      if (
        data?.length > GlobalConfiguration.lengthCheckZero &&
        response?.payload?.status === true
      ) {
        setShowLoader(false);
        handleConfirmAlert(data);
        setRejectTxnPopup(false);
        setshowPopupReject(false);
      }
    } finally {
      setShowLoader(false);
    }
  };

  const handleConfirmAlert = async (transactions) => {
    try {
      const reason = declineReason;

      const ids = transactions?.map((t) => t.txn_id) || [];

      UniversalRefreshToast("Rejecting transaction");

      if (ids.length > GlobalConfiguration.lengthCheckZero) {
        const data = await dispatch(
          beneficiaryTransactionsReject({
            id: ids,
            reason,
          }),
        );

        if (beneficiaryTransactionsReject.fulfilled.match(data)) {
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });

          setDeclineReason("");
        } else if (beneficiaryTransactionsReject.rejected.match(data)) {
          const error_msg = data?.payload?.errors?.user_unauthorized
            ? data.payload.errors.user_unauthorized[0]
            : Array.isArray(data?.payload?.errors?.base) &&
                Array.isArray(data?.payload?.errors?.base?.[0]?.errors)
              ? data.payload.errors.base[0].errors[0]
              : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
      }

      await dispatch(beneficiaryAccountDetailsById({ id }));
      setDeclineReason("");
    } catch (error) {
      setShowLoader(false);

      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);

    if (
      beneficiaryAccountDetailsData?.beneficiary_accounts[0]
        ?.pending_beneficiary_transactions === "Y"
    ) {
      setshowPopupReject(false);
      setRejectTxnPopup(true);
      setShowLoader(false);

      setPreventMultiEnter(true);
    } else if (
      beneficiaryAccountDetailsData?.beneficiary_accounts[0]
        ?.pending_scheduled_beneficiary_transactions === "Y"
    ) {
      setshowPopupReject(false);
      setShowScheduleTxnPopup(true);

      setShowLoader(false);
    } else {
      await handleConfirmDecline(id, AccountIdData);
    }
  };

  const openAssociatedAccountsFound = () => {
    dispatch(panLookUp({ pan_number: currentAccountDetails.pan }));
    dispatch(
      bankLookUp({
        ifsc: currentAccountDetails.ifsc_code,
        bank_account_no: currentAccountDetails.bank_acc_no,
        bank_account_holder_full_name:
          currentAccountDetails.bank_account_holder_full_name,
      }),
    );

    if (accountType === "beneficiary") {
      setOpenBeneAssociate(true);
    }
  };

  const createTransaction = () => {
    if (
      currentAccountDetails.categoryIds.length <=
      GlobalConfiguration?.lengthCheckZero
    ) {
      return CommonToast({
        text: "Category can't be blank",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }

    navigate(
      "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
      {
        state: currentAccountDetails,
      },
    );
  };

  const handleApprovalDetails = async (id) => {
    setShowLoader(true);
    setTimeout(
      () => setShowLoader(false),
      IntervalConfiguration.intervalMedium,
    );
    let response;
    UniversalRefreshToast("approvalaccountsRefresh");

    if (isPopup) {
      response = await dispatch(
        approveBeneficiaryAccount({ id: payload?.bene_account_id }),
      );
    } else {
      response = await dispatch(approveBeneficiaryAccount({ id }));
    }
    toast.dismiss();
    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BAAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      let error_msg = "";
      if (response?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.beneficiary_account?.[0]) {
        error_msg = response.payload.errors.beneficiary_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "Beneficiary account already approved") {
        const updatedData =
          beneficiaryAccountDetailsData?.beneficiary_accounts.map((item) => {
            if (item.id === isPopup ? payload?.bene_account_id : id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          });
        SetViewAccountDetails(updatedData);

        if (isPopup) {
          await dispatch(
            beneficiaryAccountDetailsById({ id: payload?.bene_account_id }),
          );
        } else {
          await dispatch(beneficiaryAccountDetailsById({ id }));
        }
      } else {
        const updatedData =
          beneficiaryAccountDetailsData?.beneficiary_accounts.map((item) => {
            if (item.id === isPopup ? payload?.bene_account_id : id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "pending" : "",
                error_msg,
              };
            }
            return item;
          });

        SetViewAccountDetails(updatedData);
      }
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } else {
      const updatedData =
        beneficiaryAccountDetailsData?.beneficiary_accounts.map((item) => {
          if (item.id === isPopup ? payload?.bene_account_id : id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "approved" : "pending",
            };
          }
          return item;
        });
      SetViewAccountDetails(updatedData);

      if (isPopup) {
        await dispatch(
          beneficiaryAccountDetailsById({ id: payload?.bene_account_id }),
        );
      } else {
        await dispatch(beneficiaryAccountDetailsById({ id }));
      }
      CommonToast({
        text: "Beneficiary account approved successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (isPopup) {
        setTimeout(() => {
          payload?.closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration?.intervalExtraLarger);
      }
      if (pathName) {
        setTimeout(() => {
          navigate(pathName);
        }, IntervalConfiguration?.intervalPopup);
      }

      if (txn_single_appr === "txn_single_approval") {
        setTimeout(() => {
          navigate(IntervalConfiguration?.navigate_back);
        }, IntervalConfiguration?.intervalExtraLarger);
      }
    }
  };

  const handleDeclinedDetials = (id) => {
    setClickedBtn("reject");
    setshowPopupReject(true);
    SetdeniedId(id);
    setassociatePending("");
    setassociateschedule("");
  };

  const handleClosePopup = () => {
    // setRejectTxnPopup(false);
    setshowPopupReject(false);
    if (!isPopup) {
      setPreventMultiEnter(false);
      if (payload?.type === "scheduleAcc") {
        setShowScheduleTxnPopup(false);
      }
    }
    setDeclineReason("");
  };
  const updateAllAccounts = (updatedAccounts) => {
    SetViewAccountDetails(updatedAccounts);
  };

  const handleAccountSelection = (beneAccountId) => {};

  const handleArchiveButton = async () => {
    setAchivedOpenPop(false);

    if (pendingTxn) {
      setRejectTxnPopup(true);
    } else if (scheduleTxn) {
      setShowScheduleTxnPopup(true);
    } else {
      await archiveAccount();
    }
  };

  const handleFunction = () => {
    if (associatePending === "AlertPendingTxn") {
      handleRejectAlert();
    } else if (associateschedule === "AlertSchedule") {
      handleRejectScheduleTxn();
    } else if (archiveType === "archive" && showRejectTnxPopup) {
      handleRejectAllTransaction();
    } else if (archiveType === "archive" && showScheduleTxnPopup) {
      handleRejectScheduleTxn();
    } else {
      handleRejectTransactionChecker(deniedId, declineReason);
    }
  };

  const archiveAccount = async () => {
    UniversalRefreshToast("archive");

    const archivedResponse = await dispatch(
      archiveBeneficiaryAccount({
        id,
        Navigate: navigate,
      }),
    );
    if (
      archiveBeneficiaryAccount.fulfilled.match(archivedResponse) ||
      archivedResponse.payload === "Beneficiary account already archived"
    ) {
      await dispatch(beneficiaryAccountDetailsById({ id }));
    }

    handleCloseModal();
    setAchivedOpenPop(false);
    setArchiveType("");
  };

  const handleUnArchiveButton = async () => {
    let thunkAction = unarchiveBeneficiaryAccount;
    UniversalRefreshToast("unarchive");
    const unarchived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      unarchived_response.type !== "unachivedAccountDetail/rejected" ||
      unarchived_response.payload === "Beneficiary account already pending"
    ) {
      await dispatch(beneficiaryAccountDetailsById({ id }));
    }
    handleCloseModal();
  };

  // useEffect

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("beneficiaryAccountLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [payload?.bene_account_id, id, dispatch]);

  useEffect(() => {
    if (beneficiaryAccountDetailsData) {
      SetViewAccountDetails(
        beneficiaryAccountDetailsData?.beneficiary_accounts,
      );
    }
  }, [beneficiaryAccountDetailsData]);

  useEffect(() => {
    if (
      beneficiaryAccountDetailsData &&
      beneficiaryAccountDetailsData.beneficiary_accounts &&
      beneficiaryAccountDetailsData.beneficiary_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const {
        bank_name,
        bank_acc_no,
        category_ids,
        ifsc_code,
        id,
        pan_no,
        name,
      } = beneficiaryAccountDetailsData.beneficiary_accounts[0];
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        categoryIds: (category_ids || []).map((c) => c.category_id ?? c.id),
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [beneficiaryAccountDetailsData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    let accountData = [];
    if (beneficiaryAccountDetailsData) {
      accountData = beneficiaryAccountDetailsData?.beneficiary_accounts[0].logs;
    }
    if (
      accountData &&
      beneficiaryAccountDetailsData?.beneficiary_accounts[0].archived === "Y"
    ) {
      setNameArchive(
        [...accountData]
          .filter((fil) => {
            if (fil.action === "Archived") {
              return true;
            } else return false;
          })
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[0]
          ?.user_full_name,
      );
    }
  }, [ViewAccountDetails]);

  useEffect(() => {
    if (beneficiaryAccountDetailsData) {
      dispatch(panLookUp({ pan_number: currentAccountDetails.pan }));
      dispatch(
        bankLookUp({
          ifsc: currentAccountDetails.ifsc_code,
          bank_account_no: currentAccountDetails.bank_acc_no,
        }),
      );
    }
  }, [
    currentAccountDetails.pan,
    currentAccountDetails.ifsc_code,
    currentAccountDetails.bank_acc_no,
  ]);

  useEffect(() => {
    sessionStorage.removeItem("PAN GST Edit NewValue");
  }, []);

  const handleRejectScheduleTxn = async () => {
    let id2 =
      !scheduledBeneficiaryViewLoading &&
      scheduledBeneficiaryViewData?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero
        ? scheduledBeneficiaryViewData?.transactions.map((data) => data?.txn_id)
        : [];
    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        scheduledBeneficiaryReject({
          id: id2,
          reason: declineReason,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";
        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });

        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setShowScheduleTxnPopup(false);

        const accountId = isPopup ? payload?.bene_account_id : id;

        if (archiveType === "archive") {
          await archiveAccount();
        } else if (associateschedule !== "AlertSchedule") {
          await handleConfirmDecline(accountId, declineReason);
        } else {
          await dispatch(beneficiaryAccountDetailsById({ id: accountId }));
        }
      }
      setDeclineReason("");
      setshowPopupReject(false);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      addBeneficiaryAccountLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );
    if (addBeneficiaryAccountLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    if (addBeneficiaryAccountLabel.rejected.match(res)) {
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelLoading(false);
    if (addBeneficiaryAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      removeBeneficiaryAccountLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeBeneficiaryAccountLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    if (removeBeneficiaryAccountLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelLoading(false);
    if (removeBeneficiaryAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (payload?.showCategory) {
      setIndex(GlobalConfiguration?.lengthCheckOne);
      setShowCategories(true);
      setShowContactDetails(false);
      setShowAssignedLabels(false);
      setAdditionalRecipicent(false);
    } else {
      setIndex(GlobalConfiguration?.lengthCheckZero);
      setShowCategories(false);
      setShowAssignedLabels(false);
      setAdditionalRecipicent(false);
      setShowContactDetails(true);
    }
  }, [id, payload?.bene_account_id, payload?.showCategory]);

  const rejectPopupContent = (() => {
    if (showScheduleTxnPopup) {
      return {
        headerTitle: "Rejecting Schedules",
        bulletPoints: [
          "Once rejected, no transaction will be created.",
          "Rejected schedules cannot be edited. Create a new schedule instead.",
        ],
      };
    }

    if (showRejectTnxPopup) {
      return {
        headerTitle: "Rejecting Transactions",
        bulletPoints: [
          "Transaction will be rejected, and distribution will not be initiated.",
          "Transaction cannot be edited but can be recreated.",
        ],
      };
    }

    return {
      headerTitle: "Reject account",
      bulletPoints: [
        "New transactions cannot be created for this account.",
        "Before rejecting this account, reject all associated transactions and schedules.",
        "Users can edit the rejected account to update details.",
      ],
    };
  })();

  return (
    <>
      <>{RestrictedActionPopup}</>
      {editHistoryPopUp && (
        <CommonEditHistoryPopUp
          closehandleFunction={() => setEditHistoryPopUp(false)}
          resourceType="beneficiary_accounts"
          resourceId={isPopup ? payload?.bene_account_id : id}
        />
      )}
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}

      {openLabelSearchPopup && (
        <BeneficiaryAccountViewAllPopup
          id={currentAccountDetails.id}
          type={"openLabelSearchPopup"}
          onClose={() => {
            setOpenLabelSearchPopup(false);
          }}
          onAccountSelect={handleAccountSelection}
          labelName={labelName}
        
        />
       
      )}

      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: ViewAccountDetails?.[0]?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={ViewAccountDetails?.[0]?.gstin_detail}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${ViewAccountDetails?.[0]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <IFSCDetails
              ifsc_code={ViewAccountDetails?.[0]?.ifsc_code}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: ViewAccountDetails?.[0]?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={ViewAccountDetails?.[0]?.pan_no}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            btnOneHandleFunction={handleModalClose}
            headerTitle="Select the option to edit:"
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoHandleFunction={handleApply}
            btnTwoIsDisabled={
              selectedChipIndex === null ||
              selectedChipIndex === GlobalConfiguration.lengthCheckZero
            }
            btnTwoInActiveVariantNeeded
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            defaultHeight={selectedChipIndex}
          />
        </div>
      )}
      <div id="webviewdetailPage" className={`${isPopup ? " h-full" : ""}`}>
        <div
          className={`main-div flex flex-col ${isPopup ? " h-full" : "h-screen"}  ${
            achivedOpenPop || isEditModalOpen
              ? "overflow-hidden"
              : isPopup
                ? " overflow-x-hidden"
                : "overflow-y-auto overflow-x-hidden"
          }`}
        >
          {showRejectTnxPopup && (
            <LargePopupRedirect
              headerTitle="Associated transactions found"
              headersubtext={`The following transactions are linked and need to be rejected before ${
                archiveType === "archive" ? "archiving" : "rejecting"
              } this account.`}
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                setRejectTxnPopup(false);
                setDeclineReason("");
                setassociatePending("");
                setArchiveType("");
              }}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              bottomHeaderTextNeed={true}
              bottomHeaderText={`To ${
                archiveType === "archive" ? "archive" : "reject"
              } the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason.`}
              isbottomSectionneed={true}
              btnText={"Reject all"}
              hoverOption="black"
              confirmbtnrequired={true}
              handleFunction={() => {
                const hasAccess = services?.find(
                  (service) => service === "BAAccount" || service === "Admin",
                );
                if (!hasAccess) return;

                if (archiveType === "archive") {
                  if (!declineReason) {
                    setshowPopupReject(true);
                  } else {
                    handleRejectAllTransaction();
                  }
                } else if (associatePending === "AlertPendingTxn") {
                  handleAccRejectAlert();
                } else {
                  handleRejectAllTransaction();
                }
              }}
              enabledBgColor={"var(--negative-act)"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              inActiveVariantNeeded
              isDisabled={
                services?.find((service) => service === "ABeneficiaryTxn") ===
                undefined
              }
              disabledTextColor={"var(--text-primary)"}
              disabledBgColor={"var(--text-disabled)"}
            >
              {showRejectTnxPopup && (
                <>
                  <BeneficiaryTransactionViewall
                    bene_account_id={payload?.bene_account_id || id}
                    typepop={"BeneAccRejectTxn"}
                    flowType={
                      payload?.type === "scheduleAcc"
                        ? "scheduleAcc"
                        : associatePending === "AlertPendingTxn"
                          ? "AlertPendingTxn"
                          : "decline account details"
                    }
                    closeRejectAllTxn={handleClosePopup}
                    bene_account_name={
                      beneficiaryAccountDetailsData?.beneficiary_accounts[0]
                        ?.name
                    }
                    handleRejectAllTransaction={
                      associatePending === "AlertPendingTxn"
                        ? handleAccRejectAlert
                        : handleRejectAllTransaction
                    }
                    type={payload?.type || "bene_account_detail_modal"}
                    setShowLoader={setShowLoader}
                    setSidebarState={(e) => {}}
                    setShowScheduleTxnPopup={setShowScheduleTxnPopup}
                    showLoader={showLoader}
                    setFocus={(e) => {}}
                  />
                </>
              )}
            </LargePopupRedirect>
          )}
          {showScheduleTxnPopup && (
            <LargePopupRedirect
              headerTitle="Associated schedules found"
              headersubtext={`The following schedules are linked and need to be rejected before ${
                archiveType === "archive" ? "archiving" : "rejecting"
              } this account.`}
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                setShowScheduleTxnPopup(false);
                setDeclineReason("");
                setassociateschedule("");
                setArchiveType("");
              }}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              bottomHeaderTextNeed={true}
              bottomHeaderText={`To ${
                archiveType === "archive" ? "archive" : "reject"
              } the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason.`}
              isbottomSectionneed={true}
              btnText={"Reject all"}
              confirmbtnrequired={true}
              handleFunction={() => {
                const hasAccess = services?.find(
                  (service) =>
                    service === "BAScheduledTxn" || service === "Admin",
                );
                if (!hasAccess) return;

                if (archiveType === "archive") {
                  if (!declineReason) {
                    setshowPopupReject(true);
                  } else {
                    handleRejectScheduleTxn();
                  }
                } else if (associateschedule === "AlertSchedule") {
                  handleAlertSchedule();
                } else {
                  handleRejectScheduleTxn();
                }
              }}
              enabledBgColor={"var(--negative-act)"}
              hoverOption={"black"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              inActiveVariantNeeded
              isDisabled={
                services?.find((service) => service === "BAScheduledTxn") ===
                undefined
              }
              disabledTextColor={"var(--text-primary)"}
              disabledBgColor={"var(--text-disabled"}
            >
              <ScheduleBeneficiaryTransactionViewSchedules
                type={"ScheduleAccBeneAcc"}
                payload={{
                  schedule_acc_id: payload?.bene_account_id || id,
                  number: "swadfsafs",

                  schedule_acc_name:
                    beneficiaryAccountDetailsData?.beneficiary_accounts[0]
                      ?.name,
                  handleRejectAllTransaction:
                    associateschedule === "AlertSchedule"
                      ? handleAlertSchedule
                      : handleRejectScheduleTxn,
                }}
                closeCallback={handleClosePopup}
              />
            </LargePopupRedirect>
          )}
          {loading ? (
            <div className="loader-container m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : (
            <>
              <div
                className={`bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-width-full z-z-index-overlay Qmd:hidden ${isPopup && "hidden"}`}
              >
                <TopNavComponent
                  isFormattingNotRequired={true}
                  topNavHeader={"Beneficiary"}
                  topNavSubText="Account details"
                />
              </div>
              <div
                className={`h-auto Qmd:bg-primary-nav bg-primary-card ${isPopup ? null : "mt-[var(--navbar-height)]"}`}
              >
                {showPopupReject && (
                  <BeneAccountDeclinePopup
                    headerTitle={rejectPopupContent.headerTitle}
                    bulletPoints={rejectPopupContent.bulletPoints}
                    declineReason={declineReason}
                    setDeclineReason={setDeclineReason}
                    showLoader={showLoader}
                    setShowLoader={setShowLoader}
                    handleClosePopup={handleClosePopup}
                    handleFunctionClick={handleFunction}
                  />
                )}

                {openBeneAssociate && (
                  <BeneficiaryAccountViewAllPopup
                    id={currentAccountDetails.id}
                    type={payload?.type}
                    onClose={handleCloseModal}
                    onAccountSelect={handleAccountSelection}
                    associateAccount={true}
                    associatepanNumber={currentAccountDetails.pan}
                    associateIFSC={currentAccountDetails.ifsc_code}
                    associateaccountNumber={currentAccountDetails.bank_acc_no}
                    setOpenBeneAssociate={setOpenBeneAssociate}
                    beneAccountId={currentAccountDetails.id}
                    accountType={accountType}
                    flow={"beneTxn"}
                    ispanbankRequired={true}
                    activeType={activeType}
                    setActiveType={setActiveType}
                    setRemPan={setRemPan}
                    setRemAccount={setRemAccount}
                    setRemIFSC={setRemIFSC}
                    remPan={remPan}
                    remAccount={remAccount}
                    remIFSC={remIFSC}
                    typePanBank={"BeneAccPanBankSwitch"}
                    handleClick={handleClick}
                  />
                )}
                {unachivedOpenPop && (
                  <div
                    onClick={() => setUnachivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <SmallPopupWithBulletPoints
                      headerTitle={"Confirm unarchiving this account?"}
                      btnOneText="Cancel"
                      btnOneBtnType="button"
                      btnOneEnabledBgColor="transparent"
                      btnOneHandleFunction={handleCloseModal}
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneIsDisabled={false}
                      btnOneHoverOption="white"
                      btnTwoText="Unarchive"
                      btnTwoBtnType="button"
                      btnTwoHandleFunction={handleUnArchiveButton}
                      btnTwoEnabledBgColor="var(--positive-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={false}
                      btnTwoHoverOption="black"
                      bulletPoints={[
                        "This account will become active.",
                        "The status will be changed to pending and will require approval.",
                      ]}
                    />
                  </div>
                )}
                {achivedOpenPop && (
                  <div
                    onClick={() => setAchivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <SmallPopupWithBulletPoints
                      headerTitle={"Confirm archiving this account?"}
                      headerFontWeight="semibold"
                      headerFontColor="text-primary"
                      textSize="font-md"
                      btnOneText="Cancel"
                      btnOneBtnType="button"
                      btnOneEnabledBgColor="transparent"
                      btnOneHandleFunction={handleCloseModal}
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneIsDisabled={false}
                      btnOneHoverOption="white"
                      btnTwoText="Archive"
                      btnTwoBtnType="button"
                      btnTwoHandleFunction={() => {
                        setArchiveType("archive");
                        handleArchiveButton();
                      }}
                      btnTwoEnabledBgColor="var(--negative-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={false}
                      btnTwoHoverOption="black"
                      bulletPoints={[
                        "This account will become inactive.",
                        "Account cannot be used unless unarchived.",
                      ]}
                    />
                  </div>
                )}

                {openTransHistory && (
                  <LargePopupRedirect
                    headerTitle={"Transaction history"}
                    headersubtext={
                      "All transactions related to the beneficiary are listed below."
                    }
                    closeiconenabledBgColor="var(--primary-nav)"
                    closeiconisLoading={false}
                    closeiconhandleFunction={() => closeTransactionHistory()}
                    closeicon={ICONS?.CLOSE}
                    closeiconhoverOption="white"
                    closeiconbtnType={"button"}
                    closeiconisDisabled={false}
                    closeicondisabledBgColor={""}
                    closeiconbuttonRef={null}
                    closeicontitle={"Close"}
                    btnType={"button"}
                    enabledBgColor={"var(--negative-act)"}
                    hoverOption={"dark"}
                    outLineColor={""}
                    enabledTextColor={"var(--text-primary)"}
                    fullWidthRequired={false}
                    isDisabled={false}
                    disabledTextColor={""}
                    disabledBgColor={""}
                  >
                    <BeneficiaryTransactionViewall
                      bene_account_name={
                        beneficiaryAccountDetailsData?.beneficiary_accounts[0]
                          ?.name
                      }
                      bene_account_id={
                        beneficiaryAccountDetailsData?.beneficiary_accounts[0]
                          ?.id
                      }
                      bene_account_confidential={null}
                      onClose={closeTransactionHistory}
                      typepop={"txnHistorypopup"}
                    />
                  </LargePopupRedirect>
                )}
                {showLabelsPopup && (
                  <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
                    <CommonAssignLabelPopup
                      headerTitle="Assign/unassign labels:"
                      headersubtext="Labels will be used to generate statistics for the associated accounts."
                      closehandleFunction={handleClose}
                      closeisDisabled={false}
                      labels={labels}
                      setLabels={setLabels}
                      LabelAccounts={id}
                      isLabelPopupOpen={showLabelsPopup}
                      filteredData={
                        beneficiaryAccountDetailsData?.beneficiary_accounts
                      }
                      onClose={handleClose}
                      loading={labelLoading}
                      setLoading={setLabelLoading}
                      handleAssignLabels={handleAssignLabelsProp}
                      handleUnassignLabels={handleUnassignLabelsProp}
                    />
                  </div>
                )}
                <div
                  className={`w-full max-w-screen-Qlg m-auto Qmd:bg-primary-nav bg-primary-card ${isPopup ? "" : "Qmd:mt-margin-sm"}`}
                  id="container"
                >
                  <div className="flex w-full bg-primary-nav m-auto h-height-sm Qlg:px-padding-base">
                    <div
                      className={`w-full ${isPopup ? "" : "mt-margin-base Qmd:mt-margin-lg"}`}
                    >
                      {beneficiaryAccountDetailsData?.beneficiary_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="flex border-b border-solid border-primary-bg justify-between mx-margin-md Qmd:mx-margin-base"
                          >
                            <div className="flex flex-col Qmd:flex-row w-full ">
                              <div className="py-padding-md w-full Qmd:w-right-half border-b Qmd:border-b-border-base border-solid border-primary-bg">
                                <div className="flex flex-col Qmd:pl-padding-sm">
                                  <TitleSubtitlePair
                                    title={account.name.trim()}
                                    titleColor="text-primary "
                                    subtitle={
                                      account?.name?.trim() ===
                                      account?.pan_legal_name?.trim()
                                        ? "Account name - Using legal name"
                                        : "Account name"
                                    }
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>
                              <div className="hidden Qmd:block border-r border-solid border-primary-bg my-margin-md"></div>
                              {ViewAccountDetails?.map((account) => (
                                <div
                                  key={account.id}
                                  className="w-full Qmd:w-right-half py-padding-md"
                                >
                                  <div className="flex flex-col items-start Qmd:pl-padding-md">
                                    <TitleSubtitlePair
                                      title={
                                        (services?.includes("BAAccount") ||
                                          services?.includes("Admin")) &&
                                        account?.approval_status === "pending"
                                          ? "Require approval"
                                          : account?.approval_status === "error"
                                            ? "Pending"
                                            : account?.approval_status
                                                ?.toLowerCase()
                                                ?.split(" ")
                                                ?.map(
                                                  (word) =>
                                                    word
                                                      .charAt(
                                                        GlobalConfiguration?.lengthCheckZero,
                                                      )
                                                      .toUpperCase() +
                                                    word.slice(
                                                      GlobalConfiguration?.lengthCheckOne,
                                                    ),
                                                )
                                                ?.join(" ")
                                      }
                                      titleColor={`${
                                        account.approval_status === "pending" ||
                                        account.approval_status === "error"
                                          ? "pending"
                                          : account.approval_status ===
                                              "approved"
                                            ? "awaiting"
                                            : account.approval_status ===
                                                "rejected"
                                              ? "failed"
                                              : account.approval_status ===
                                                  "blocked"
                                                ? "failed"
                                                : account.approval_status ===
                                                    "archived"
                                                  ? "abandoned"
                                                  : ""
                                      }`}
                                      subtitle="Account status"
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={false}
                                      variant="md"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="h-auto Qmd:flex flex-row bg-primary-nav-act hidden">
                              {/* <TopNavSmallButton
                                btnText={
                                  <>
                                    Switch
                                    <br />
                                    account type
                                  </>
                                }
                                handleFunction={() => {
                                  switchAccountType();
                                }}
                                icon={ICONS?.SWITCH_ACCOUNT}
                                imgColor={"var(--text-primary)"}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={isPopup}
                                hoverOption="white"
                              />
                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div> */}
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Associated
                                    <br />
                                    accounts
                                  </>
                                }
                                handleFunction={() => {
                                  if (isPopup) {
                                    actionRestricted();
                                    return;
                                  }
                                  setRemPan(currentAccountDetails.pan);
                                  openAssociatedAccountsFound();
                                }}
                                icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={isPopup}
                                hoverOption="white"
                              />

                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Transaction <br /> history
                                  </>
                                }
                                handleFunction={() => {
                                  if (isPopup) {
                                    actionRestricted();
                                    return;
                                  }
                                  openTransactionHistory();
                                }}
                                icon={ICONS?.TRANSACTION_HISTORY}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                hoverOption="white"
                                isDisabled={isPopup}
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {beneficiaryAccountDetailsData?.beneficiary_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="h-auto flex border-b border-solid border-primary-bg justify-between mx-margin-md Qmd:mx-margin-base"
                          >
                            <div className="flex flex-col Qmd:flex-row w-full">
                              <div className="py-padding-md Qmd:pl-padding-sm flex gap-gap-sm justify-between items-center Qmd:pr-padding-md w-full Qmd:w-right-half Qmd:border-b-border-base border-b border-solid border-primary-bg">
                                <TitleSubtitlePair
                                  title={formatAccountNumber(
                                    account.bank_acc_no,
                                  )}
                                  titleColor="text-primary"
                                  subtitle="  Account number"
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={false}
                                  variant="md"
                                />
                                <div className="h-[max-content] flex justify-center items-center bg-text-primary rounded-border-radius-md">
                                  <CommonBankLogo
                                    ifsc={account?.ifsc_code}
                                    variant="big"
                                    type="pill"
                                  />
                                </div>
                              </div>
                              <div className="hidden Qmd:block border-r border-solid border-primary-bg my-margin-md"></div>
                              <div className="py-padding-md w-full Qmd:w-right-half">
                                <div className="flex flex-col items-start Qmd:pl-padding-md">
                                  <TitleSubtitlePair
                                    title={
                                      account.bank_account_holder_full_name
                                    }
                                    titleColor="text-primary"
                                    subtitle=" Bank account holder name"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="settings Qmd:flex flex-row hidden justify-end bg-primary-nav-act">
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Edit <br /> account
                                  </>
                                }
                                handleFunction={() => {
                                  if (isPopup) {
                                    return actionRestricted();
                                  }
                                  if (!canEdit) {
                                    return navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "BUAccount",
                                      },
                                    });
                                  }
                                  handleModalOpen(id);
                                }}
                                icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                hoverOption="white"
                                isDisabled={isEditDisabled}
                              />
                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {isAccountArchived ? (
                                      <>
                                        Unarchive <br /> account
                                      </>
                                    ) : (
                                      <>
                                        Archive <br /> account
                                      </>
                                    )}
                                  </>
                                }
                                handleFunction={() => {
                                  if (isPopup) {
                                    return actionRestricted();
                                  }

                                  if (!canArchive) {
                                    return navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "BAAccountArchive",
                                      },
                                    });
                                  }

                                  isArchived
                                    ? handleUnarchive()
                                    : handleArchive();
                                }}
                                icon={
                                  isAccountArchived
                                    ? ICONS?.UNARCHIVE
                                    : ICONS?.ARCHIVE
                                }
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                hoverOption="white"
                                isDisabled={isArchiveDisabled}
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {beneficiaryAccountDetailsData?.beneficiary_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="h-auto flex justify-between items-center flex-col Qmd:flex-row"
                          >
                            <div className="flex Qmd:flex-row w-full">
                              <div
                                className={`flex justify-between items-center w-full Qsmd:w-right-half my-margin-sm Qmd:my-margin-base mr-margin-md ml-margin-sm  Qmd:mx-margin-base Qmd:h-positive-negative-btn-height ${account?.approval_status === "pending" || account?.approval_status === "approved" ? "" : "Qmd:pt-padding-sm Qmd:pb-padding-sm"}`}
                              >
                                <TitleSubtitlePair
                                  title={account?.ifsc_code}
                                  titleColor="text-primary "
                                  isDisabled={isPopup ? true : false}
                                  subtitle="IFSC"
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={false}
                                  variant="md"
                                  showArrow="true"
                                  onClick={() => {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "VIFSC" ||
                                          service === "Admin",
                                      ) !== undefined &&
                                      account.ifsc_code
                                    ) {
                                      if (isPopup) {
                                        actionRestricted();
                                      } else {
                                        setIfscShowPopup(true);
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "VIFSC",
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>

                              <div
                                className={`py-padding-md hidden lg:w-width-md Qsmd:w-width-sm-1-3 Qlg:flex justify-between ${
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected" ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero)
                                    ? "flex-[var(--width-md)]"
                                    : ""
                                }`}
                              >
                                <div className="flex flex-row pl-padding-sm Qmd:pl-padding-md w-full"></div>
                              </div>
                            </div>
                            <div
                              className={`flex w-full Qmd:w-width-sm-1-3  Qmd:h-auto ${
                                (ViewAccountDetails[0]?.approval_status ===
                                  "blocked" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "archived" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected") &&
                                "hidden"
                              }`}
                            >
                              <div
                                className={`${
                                  beneficiaryAccountDetailsData
                                    ?.beneficiary_accounts[0]
                                    ?.approval_status === "approved"
                                    ? "w-auto flex-grow bg-primary-nav hidden Qmd:block"
                                    : (ViewAccountDetails[0]
                                          ?.approval_status === "rejected" &&
                                          ViewAccountDetails[0]?.error_msg
                                            ?.length >
                                            GlobalConfiguration?.lengthCheckZero) ||
                                        (ViewAccountDetails[0]
                                          ?.approval_status === "pending" &&
                                          ViewAccountDetails[0]?.error_msg
                                            ?.length >
                                            GlobalConfiguration?.lengthCheckZero)
                                      ? "hidden"
                                      : "w-width-sm-1-3 bg-primary-nav hidden Qmd:block"
                                }`}
                              ></div>

                              <div
                                className={`${
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "rejected" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration?.lengthCheckZero) ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration?.lengthCheckZero)
                                    ? "flex-[var(--width-md)]"
                                    : "w-full"
                                }`}
                              >
                                <div
                                  className={`h-full w-full flex justify-end ${
                                    services?.find(
                                      (service) =>
                                        service === "CBeneficiaryTxn" ||
                                        service === "Admin",
                                    ) === undefined &&
                                    beneficiaryAccountDetailsData
                                      ?.beneficiary_accounts[0]
                                      .approval_status === "approved"
                                      ? "opacity-light-opacity cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  {ViewAccountDetails?.map((account) => (
                                    <>
                                      {showLoader ? (
                                        <>
                                          <div className="Qlg:w-max-button-width-for-approval-animation w-full flex">
                                            <div
                                              className={`w-width-full flex justify-center items-center py-padding-lg ${
                                                clickedBtn === "reject"
                                                  ? "bg-negative-act"
                                                  : "bg-positive-act"
                                              }`}
                                            >
                                              <Loader
                                                height="var(--icon-lg)"
                                                width="var(--icon-lg)"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      ) : account?.approval_status ===
                                        "approved" ? (
                                        <>
                                          <TopNavLargeButton
                                            hoverOption={"black"}
                                            isDisabled={
                                              !services?.find(
                                                (service) =>
                                                  service ===
                                                    "CBeneficiaryTxn" ||
                                                  service === "Admin",
                                              )
                                            }
                                            btnText={"Pay Beneficiary"}
                                            btnType={"button"}
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service ===
                                                      "CBeneficiaryTxn" ||
                                                    service === "Admin",
                                                ) !== undefined &&
                                                account?.approval_status ===
                                                  "approved"
                                              ) {
                                                createTransaction();
                                                sessionStorage.removeItem(
                                                  "recreate_ben",
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "CBeneficiaryTxn",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={ICONS?.PAY_WITH_CIRCLE}
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary)"
                                            }
                                            fullWidthRequired={isMobile}
                                          />
                                        </>
                                      ) : account?.approval_status ===
                                          "rejected" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account.id}
                                          className={`h-full flex justify-end  ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                                            <div className="flex place-items-center">
                                              <img
                                                src={
                                                  ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                              <span className="font-semibold font-sans text-xs text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-font-xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account.approval_status ===
                                          "pending" &&
                                        account.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account.id}
                                          className={`h-full flex justify-end Qlg:w-[unset] w-full ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row h-full w-full bg-negative-card p-padding-sm">
                                            <div className="flex place-items-center Qlg:w-1/6">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                className="w-icon-lg h-icon-lg mr-margin-button-m"
                                                alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-gap-xs w-5/6 ml-margin-sm">
                                              <span className="font-semibold font-sans text-sm text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account.approval_status ===
                                        "error" ? (
                                        <div className="flex flex-row h-full bg-negative-card p-padding-sm">
                                          <div className="flex place-items-center w-1/6">
                                            <img
                                              src={
                                                ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                              }
                                              className="w-icon-lg h-icon-lg mr-margin-button-m"
                                              alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                            />
                                          </div>
                                          <div className="flex flex-col justify-center gap-y-gap-xs w-5/6">
                                            <span className="font-semibold font-sans text-sm text-text-primary">
                                              Failed to take action
                                            </span>
                                            <div>
                                              <p className="line-clamp-3 whitespace-wrap overflow-ellipsis text-font-xs text-text-primary opacity-base-opacity">
                                                {account?.error_msg
                                                  ? account?.error_msg
                                                  : rejectBeneficiaryAccountData
                                                      ?.errors
                                                      ?.beneficiary_account?.[0]}
                                                .
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account.approval_status ===
                                        "pending" ? (
                                        <div
                                          key={account.id}
                                          className={`h-full flex justify-end w-full ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Reject <br /> account
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "BAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                handleDeclinedDetials(
                                                  payload?.bene_account_id ||
                                                    account.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "BAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={
                                              ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE
                                            }
                                            enabledBgColor={
                                              "var(--negative-act)"
                                            }
                                            isDisabled={
                                              !services?.find(
                                                (service) =>
                                                  service === "BAAccount" ||
                                                  service === "Admin",
                                              )
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />

                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Approve <br /> account
                                              </>
                                            }
                                            isDisabled={
                                              !services?.find(
                                                (service) =>
                                                  service === "BAAccount" ||
                                                  service === "Admin",
                                              )
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "BAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                setClickedBtn("approve");
                                                handleApprovalDetails(
                                                  account.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "BAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={
                                              ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK
                                            }
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />
                                        </div>
                                      ) : null}
                                    </>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-primary-bg w-full py-padding-md block Qmd:hidden">
                <div className="text-text-primary pl-padding-sm py-padding-button-l text-font-sm font-semibold bg-primary-card">
                  Quick Actions
                </div>
                <div>
                  <div className="h-auto Qmd:hidden flex flex-row border-b border-solid border-primary-bg">
                    {/* <TopNavSmallButton
                      btnText={
                        <>
                          Switch
                          <br />
                          account type
                        </>
                      }
                      handleFunction={() => {
                        switchAccountType();
                      }}
                      icon={ICONS?.SWITCH_ACCOUNT}
                      imgColor={"var(--text-primary)"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      fullWidthRequired={true}
                      isDisabled={isPopup}
                      hoverOption="white"
                    />
                    <div className="py-padding-button-l flex">
                      <div className="flex-grow border-r border-solid border-primary-bg"></div>
                    </div> */}
                    <TopNavSmallButton
                      btnText={
                        <>
                          Associated <br /> accounts
                        </>
                      }
                      handleFunction={() => {
                        if (isPopup) {
                          actionRestricted();
                          return;
                        }
                        setRemPan(currentAccountDetails.pan);
                        openAssociatedAccountsFound();
                      }}
                      icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary"}
                      hoverOption="white"
                      isDisabled={isPopup}
                      fullWidthRequired={true}
                    />

                    <div className="flex">
                      <div className="flex-grow border-l border-solid border-primary-bg"></div>
                    </div>
                    <TopNavSmallButton
                      btnText={
                        <>
                          Transaction <br /> history
                        </>
                      }
                      handleFunction={() => {
                        if (isPopup) {
                          actionRestricted();
                        } else {
                          openTransactionHistory();
                        }
                      }}
                      icon={ICONS?.TRANSACTION_HISTORY}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary"}
                      hoverOption="white"
                      isDisabled={isPopup}
                      fullWidthRequired={true}
                    />
                  </div>
                  <div className="flex flex-row bg-primary-nav-act">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Edit <br /> account
                        </>
                      }
                      handleFunction={() => {
                        if (isPopup) {
                          return actionRestricted();
                        }

                        if (!canEdit) {
                          return navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "BUAccount",
                            },
                          });
                        }
                        handleModalOpen(id);
                      }}
                      icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      isDisabled={isEditDisabled}
                      fullWidthRequired={true}
                    />
                    <div className="flex">
                      <div className="flex-grow border-l border-solid border-primary-bg"></div>
                    </div>

                    <TopNavSmallButton
                      btnText={
                        <>
                          {isAccountArchived ? "Unarchive" : "Archive"}
                          <br />
                          account
                        </>
                      }
                      handleFunction={() => {
                        if (isPopup) {
                          return actionRestricted();
                        }

                        if (!canArchive) {
                          return navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "BAAccountArchive",
                            },
                          });
                        }
                        isAccountArchived ? handleUnarchive() : handleArchive();
                      }}
                      icon={
                        isAccountArchived ? ICONS?.UNARCHIVE : ICONS?.ARCHIVE
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      isDisabled={isArchiveDisabled}
                      fullWidthRequired={true}
                    />
                  </div>
                </div>
              </div>

              <div
                className={`bg-primary-bg flex-grow w-full ${isPopup && "pb-padding-lg"}`}
              >
                <div className="w-full bg-primary-card">
                  <div className="w-full lg:w-max-content-width m-auto">
                    <CommonAlertsStrip alerts={buildAlerts()} />
                  </div>
                </div>

                <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto">
                  <div className="detail-category-button ml-margin-md lg:ml-margin-base flex Qmd:pt-padding-md pb-padding-md lg:mx-auto Qmd:mx-margin-md Qlg:mx-margin-base">
                    <div
                      className="overflow-x-auto scroll-bar mt-margin-md Qsmd:mt-margin-base"
                      style={{ scrollbarWidth: "none" }}
                    >
                      <SwitcherTabs
                        tabs={[
                          {
                            label: "Account details",
                            key: "Account details",
                            handler: toggleContactDetails,
                          },
                          {
                            label: "Categories",
                            key: "Categories",
                            handler: toggleCategories,
                          },
                          {
                            label: "Labels",
                            key: "Labels",
                            handler: toggleAssignedLabels,
                          },
                          {
                            label: "Recipients",
                            key: "Recipients",
                            handler: toggleAdditionalRecipicent,
                          },
                          {
                            label: "Support details",
                            key: "Support details",
                            handler: toggleSupportDetails,
                          },
                        ]}
                        swicherTabBgColor={"var(--primary-card)"}
                        initialActiveTab={
                          showCategories
                            ? "Categories"
                            : showAssignedLabels
                              ? "Labels"
                              : additionalRecipient
                                ? "Recipients"
                                : additionalSupport
                                  ? "Support details"
                                  : ""
                        }
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  <div className="relative pb-padding-md">
                    {index === GlobalConfiguration?.lengthCheckZero && (
                      <div className={animationClass}>
                        {ViewAccountDetails?.map((account) => {
                          let originItemList = [
                            {
                              heading: "Contact number",
                              content: account?.contact_no
                                ? `+91 ${account.contact_no}`
                                : "Not given",
                              type: "text",
                            },
                            {
                              heading: "Email ID",
                              content: account?.email_id || "Not given",
                              type: "text",
                            },
                          ];

                          let AccountItemList = [
                            {
                              heading: "PAN",
                              content: account?.pan_no || "Not given",
                              type: "text",

                              onClick: () => {
                                const hasAccess = services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                );

                                if (hasAccess && account?.pan_no) {
                                  if (isPopup) {
                                    actionRestricted();
                                  } else {
                                    handlePANDetails(account.pan_no);
                                  }
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: { unavailableService: "VPAN" },
                                  });
                                }
                              },

                              isDisabled:
                                services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                ) &&
                                account?.pan_no &&
                                !isPopup
                                  ? false
                                  : true,
                            },

                            {
                              heading: "Legal name",
                              content: account?.pan_legal_name || "Not given",
                              type: "text",
                            },
                            {
                              heading: "GSTIN",
                              content: account.gstin_detail || "Not given",
                              type: "text",

                              onClick: account?.gstin_detail
                                ? () => {
                                    if (isPopup) {
                                      actionRestricted();
                                    } else {
                                      if (!account?.gstin_detail) return;

                                      const hasAccess =
                                        services?.includes("VGSTIN") ||
                                        services?.includes("Admin");
                                      if (hasAccess) {
                                        setGstShowPopup(true);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VGSTIN",
                                          },
                                        });
                                      }
                                    }
                                  }
                                : undefined,
                              isDisabled:
                                services?.some(
                                  (service) =>
                                    service === "VGSTIN" || service === "Admin",
                                ) && !isPopup
                                  ? false
                                  : true,
                            },
                            ...(account?.virtual_account === "Y"
                              ? [
                                  {
                                    content:
                                      account?.virtual_account === "N"
                                        ? ""
                                        : account?.virtual_account_type ===
                                            "manual"
                                          ? "Manually created"
                                          : account?.virtual_account_type ===
                                              "automated" && "Auto detected",
                                    heading:
                                      account?.virtual_account === "N"
                                        ? ""
                                        : "Virtual account",
                                    type: "text",
                                  },
                                ]
                              : []),
                            {
                              heading: "Account state",
                              content: account?.account_type || "Not given",
                              type: "text",
                              isDisabled: isPopup,
                              onClick: () => {
                                if (isPopup) {
                                  actionRestricted();
                                  return;
                                }

                                if (services?.includes("PLogin")) {
                                  setEditHistoryPopUp(true);
                                } else {
                                  return navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "PLogin",
                                    },
                                  });
                                }
                              },
                            },
                          ];

                          return (
                            <div className="flex flex-col lg:flex-row mb-margin-xl gap-gap-md mx-margin-md lg:mx-auto">
                              <CommonDetailCard
                                cardTitle="Account Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={AccountItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Contact Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={originItemList}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {index === GlobalConfiguration?.lengthCheckOne && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ASSIGNED_BENEFICIARY_CATEGORIES}
                        >
                          {sliceCategory.filter((item) => item.active === "Y")
                            .length ===
                          beneficiaryAccountDetailsData
                            ?.beneficiary_accounts?.[0]?.category_ids
                            ?.length ? (
                            <div className="flex mb-margin-button-l items-center">
                              <img
                                className="w-icon-md h-icon-md mr-margin-sm"
                                src={ICONS?.ALERT}
                                alt="alert"
                              />
                              <p className="text-text-primary text-sm font-normal">
                                {TEXT?.ALL_CATEGORIES_ASSIGNED_WARNING}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            className={`${
                              beneficiaryAccountDetailsData
                                ?.beneficiary_accounts?.[0]?.category_ids
                                ?.length > GlobalConfiguration?.lengthCheckZero
                                ? "flex-row items-center flex-wrap"
                                : ""
                            }`}
                          >
                            {beneficiaryAccountDetailsData?.beneficiary_accounts.map(
                              (account, index) => (
                                <div key={index}>
                                  <div className="flex flex-col Qmd:flex-row Qmd:flex-wrap gap-gap-sm">
                                    {account.category_ids?.length >
                                    GlobalConfiguration.lengthCheckZero
                                      ? account.category_ids.map((category) => (
                                          <div
                                            className="w-full bg-primary-nav-act rounded-border-radius-sm max-w-none Qmd:max-w-detail-page-category-grid flex flex-row items-center"
                                            key={category.category_id}
                                          >
                                            <div className="bg-text-secondary rounded-border-radius-sm flex justify-center items-center opacity-base-opacity">
                                              <div className="w-icon-lg h-icon-lg my-margin-button-s mx-margin-sm max-w-none">
                                                <SVGComponent
                                                  url={
                                                    categoryMapper(
                                                      category.category_id,
                                                    )?.url
                                                  }
                                                  color={
                                                    categoryMapper(
                                                      category.category_id,
                                                    )?.colour
                                                  }
                                                />
                                              </div>
                                            </div>

                                            <div className="truncate px-padding-sm text-sm text-text-primary text-left font-sans font-semibold opacity-base-opacity">
                                              <TickerAnimation
                                                text={category.category_name}
                                              />
                                            </div>
                                          </div>
                                        ))
                                      : null}
                                  </div>

                                  {!account.category_ids?.length && (
                                    <p
                                      key={`notFound_${index}`}
                                      className="text-text-primary text-sm"
                                    >
                                      {TEXT?.ASSIGN_CATEGORY_WARNING}
                                    </p>
                                  )}
                                </div>
                              ),
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckTwo && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header="Assigned Labels"
                          subheader="Labels will be used to generate statistics for the associated accounts."
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (
                              !services?.includes("ALabel") &&
                              !services?.includes("RLabel")
                            ) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }
                            if (isPopup) {
                              actionRestricted();
                              return;
                            }
                            setShowLabelsPopup(true);
                          }}
                          icon={ICONS?.EDIT}
                          iconIsDisabled={isPopup ? true : false}
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length >
                              GlobalConfiguration.lengthCheckZero ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Chips
                                    txtChip={item}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav)"
                                    isTickerRequired={false}
                                    hoverOptionBtn="white"
                                    handleFunctionBtn={() => {
                                      if (isPopup) {
                                        actionRestricted();
                                        return;
                                      }
                                      setLabelName(item);
                                      setOpenLabelSearchPopup(true);
                                    }}
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                No labels assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}
                    {index === GlobalConfiguration?.lengthCheckThree && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ADDITIONAL_RECIPIENTS}
                          subheader={TEXT?.ADDITIONAL_RECIPIENTS_CARD_SUBTEXT}
                          icon={ICONS?.EDIT}
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (isPopup) {
                              actionRestricted();
                              return;
                            }
                            if (!ensureAll(["BUAccount"]).status) {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "BUAccount" },
                              });
                              return;
                            }
                            if (
                              ViewAccountDetails[0].approval_status ===
                                "archived" ||
                              ViewAccountDetails[0].approval_status ===
                                "blocked"
                            ) {
                              return;
                            } else {
                              setShowAdditionalSection(true);
                              setAdditionalChip(showAdditionalRecipient);
                            }
                          }}
                          iconIsDisabled={
                            !ensureAll(["BUAccount"]).status
                              ? true
                              : ViewAccountDetails[0].approval_status ===
                                    "archived" ||
                                  ViewAccountDetails[0].approval_status ===
                                    "blocked"
                                ? true
                                : isPopup
                                  ? true
                                  : false
                          }
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(showAdditionalRecipient) &&
                            showAdditionalRecipient.length >
                              GlobalConfiguration?.lengthCheckZero ? (
                              <>
                                {showAdditionalRecipient.map((item, index) => (
                                  <div
                                    key={index}
                                    className="flex flex-row items-center py-padding-button-m px-padding-button-l rounded-border-radius-md relative bg-primary-nav-act max-w-max_width-full"
                                  >
                                    <span className="text-text-primary text-font-xs font-normal break-all">
                                      {linkIdentifier(item)}
                                    </span>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <span className="text-text-primary text-sm font-normal">
                                {TEXT?.NO_ADDITIONAL_RECIPIENTS_ADDED}
                              </span>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}
                    {index === GlobalConfiguration?.lengthCheckFour && (
                      <div className={animationClass}>
                        {ViewAccountDetails?.map((account) => {
                          const originTimelineItemList = [
                            {
                              heading: "Created by",
                              content: account?.created_by_name || "Not given",
                              type: "text",
                            },
                            {
                              heading: "Created on",
                              content: account.created_on
                                ? formatDateViewAll(
                                    account.created_on,
                                    true,
                                    true,
                                  )
                                : "Not given",
                              type: "text",
                            },
                            ...(account.approval_status === "approved"
                              ? [
                                  {
                                    heading: "Approved by",
                                    content:
                                      account.approved_by_name || "Not given",
                                    type: "text",
                                  },
                                  {
                                    heading: "Approved on",
                                    content: account.approved_on
                                      ? formatDateViewAll(
                                          account.approved_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    type: "text",
                                  },
                                ]
                              : []),
                            ...(account.approval_status === "rejected"
                              ? [
                                  {
                                    heading: "Rejected by",
                                    content:
                                      account.rejected_by_name || "Not given",
                                    type: "text",
                                  },
                                  {
                                    heading: "Rejected on",
                                    content: account.rejected_on
                                      ? formatDateViewAll(
                                          account.rejected_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    type: "text",
                                  },
                                  {
                                    heading: "Rejected reason",
                                    content:
                                      account.rejection_reason || "Not given",
                                    type: "text",
                                  },
                                ]
                              : []),
                            ...(account.approval_status === "archived"
                              ? [
                                  {
                                    heading: "Archived by",
                                    content:
                                      account.archived === "Y" &&
                                      !account.archived_by_name
                                        ? nameArchive
                                        : account.archived_by_name ||
                                          "Not given",
                                    type: "text",
                                  },
                                  {
                                    heading: "Archived on",
                                    content: account.archived_on
                                      ? formatDateViewAll(
                                          account.archived_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    type: "text",
                                  },
                                ]
                              : []),
                            ...(account.approval_status === "blocked"
                              ? [
                                  {
                                    heading: "Blocked by",
                                    content:
                                      account.blocked_by_name || "Not given",
                                    type: "text",
                                  },
                                  {
                                    heading: "Blocked on",
                                    content: account.blocked_on
                                      ? formatDateViewAll(
                                          account.blocked_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    type: "text",
                                  },
                                ]
                              : []),
                          ];

                          const SupportInformationList = [
                            {
                              heading: "Account ID",
                              content: account.id,
                              type: "textWithButton",
                              iconArray: [
                                {
                                  onClick: () => handleSupportIdCopy(),
                                  title: tooltip,
                                  icon:
                                    tooltip === "Copied"
                                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                      : ICONS?.COPY,
                                },
                              ],
                            },
                          ];

                          return (
                            <div
                              key={account.id}
                              className="flex flex-col lg:flex-row mb-margin-xl gap-gap-md mx-margin-md lg:mx-auto"
                            >
                              <CommonDetailCard
                                cardTitle="Origin Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={originTimelineItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Support Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={SupportInformationList}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BeneficiaryAccountDetails;
